import { jsx as p } from "react/jsx-runtime";
import { isLight as r } from "@givebutter/util";
import { transparentChecker as m } from "./utils.js";
import { twMerge as d } from "tailwind-merge";
const f = ({ color: t, className: s, style: n = {}, ...a }) => {
  const i = r(t), e = (t == null ? void 0 : t.toLowerCase()) === "transparent";
  return /* @__PURE__ */ p(
    "span",
    {
      className: d(
        "inline-block size-5 rounded-lg",
        (i || e) && "border border-gray-300",
        s
      ),
      style: { ...n, background: e ? m : t },
      ...a
    }
  );
}, h = (t) => r(t) || (t == null ? void 0 : t.toLowerCase()) === "transparent" ? "#d1d1d6" : t;
export {
  f as Swatch,
  h as getFocusColor
};
